import { fromJS } from 'immutable';
import actions from '../constants';

const initialState = fromJS({
  loading: false,
});

const update = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_START:
    case actions.CREATE_START:
    case actions.DELETE_START:
      return state.set('loading', true).delete('error');
    case actions.GET_FINISH:
    case actions.CREATE_FINISH:
    case actions.DELETE_FINISH:
      return state.set('loading', false);
    case actions.GET_ERROR:
    case actions.CREATE_ERROR:
    case actions.DELETE_ERROR:
      return state.set('loading', false).set('error', action.error.message || action.error);
    default:
      return state;
  }
};

export default update;



// WEBPACK FOOTER //
// ./src/modules/players/reducers/ui.js